import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { setProfile } from "../../../features/ProfileSlice";
import { custProfile } from "../../../services/Api/Module/Customer";
import { usePageContent } from "../../../i18n/useContentMap";

import img_icoSearch from "../../../assets/img/ci/profile/ico-search.svg";
import SwiperComponent from "../../../components/SwiperComponent";
import HeaderLink from "../../../components/HeaderLink";
import LoadingSpinner from "../../../components/loader/LoadingSpinner";

const Member = () => {
  const content = usePageContent("member"); // Get member page translations

  const dispatch = useDispatch(); // ไว้อัพเดต state กลาง
  const stateProfile = useSelector((state) => state.profile);

  // TPD URL Endpoint
  console.log("REACT_APP_TPD_URL_ENDPOINT >>>", process.env.REACT_APP_TPD_URL_ENDPOINT);
  const tpdUrl = process.env.REACT_APP_TPD_URL_ENDPOINT || "https://tpd-nprod.welcomepaypoint.com";

  const setDataProfile = (dataUser) => {
    const tmpObj = { dataUser: dataUser };
    dispatch(setProfile(tmpObj)); // setStateRedux ส่งค่าเก็บเข้า state กลาง
  };

  /* Handle goto page */
  const navigate = useNavigate();

  const handleGotoPage = (e) => {
    e.preventDefault();
    const page = e.currentTarget.dataset.page;
    navigate("/" + page);
  };

  // Handle external links for HeaderLink
  const handleExternalLink = (e, part = "") => {
    e.preventDefault();
    const urlMap = {
      myPoints: `${tpdUrl}/mypoint`,
      myCoupon: `${tpdUrl}/mycoupon`,
      memberPaypoint: `${tpdUrl}/members`,
      highlight: `${tpdUrl}/news/0`,
      codes: `${tpdUrl}/news/1`,
    };

    const targetUrl = part && urlMap[part] ? urlMap[part] : tpdUrl;

    if (targetUrl) {
      window.open(targetUrl, "_blank", "noopener,noreferrer");
    }
  };
  /* End Handle goto page */

  /* First event render */
  const [memberPointTop3, setMemberPointTop3] = useState([]);
  const [paypointPartners, setPaypointPartners] = useState([]);
  const [highlight, setHighlight] = useState([]);
  const [coupon, setCoupon] = useState([]);
  const [memberDataLoading, setMemberDataLoading] = useState(true);

  const getCustProfile = async (payload) => {
    let _return = {
      status: false,
      result: null,
    };

    try {
      const { data } = await custProfile({
        params: payload.params,
        custId: payload.custId,
      });
      if (data.resultCode === 20200) {
        const resData = data.body;
        // console.log("getCustProfile resData >>", resData);

        _return.status = true;
        _return.result = resData;
      }
    } catch (e) {
      console.log("ERR getCustProfile >> ", e);
    }

    return _return;
  };

  useEffect(() => {
    // console.log("useEffect !", stateProfile);

    if (stateProfile.id === 0 && Object.getOwnPropertyNames(stateProfile.dataUser).length === 0) {
      navigate("/");
    } else {
      // เริ่มต้นด้วย loading state
      setMemberDataLoading(true);

      // เรียก API เพื่อดึงข้อมูลใหม่
      getCustProfile({
        params: {},
        custId: stateProfile.id,
      })
        .then((_rsData) => {
          // console.log("_rsData >>", _rsData);

          if (_rsData.status === true) {
            setDataProfile(_rsData.result);

            // อัพเดทข้อมูลจาก API
            setMemberPointTop3(_rsData.result.memberPoint["top3"] || []);
            setPaypointPartners(_rsData.result.memberPoint["partners"] || []);
            setHighlight(_rsData.result.memberPoint["highlight"] || []);
            setCoupon(_rsData.result.memberPoint["coupon"] || []);
          }

          // หยุด loading เมื่อเสร็จสิ้น
          setMemberDataLoading(false);
        })
        .catch((error) => {
          console.error("Error in getCustProfile:", error);
          setMemberDataLoading(false);
        });
    }
  }, []);
  /* End First event render */

  // useEffect(() => {
  //   console.log(memberPointTop3);
  // }, [memberPointTop3]);

  return (
    <>
      <Helmet>
        <title>{content.title || "Paypoint"}</title>
        <meta name="title" content={content.title || "Paypoint"} />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content={content.title || "Paypoint"} />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Paypoint" />
      </Helmet>

      <div id="pageMember">
        <main>
          <div className="wrapContent">
            <section id="pMembercardMain">
              <div className="bMembercard">
                <div className="titleProfile">
                  <div className="bUserDetail">
                    <div className="bDtail">
                      <div className="bImg">
                        <img
                          src={stateProfile?.lineImgUrl}
                          alt="Profile"
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      </div>
                      <div className="tName">
                        <p>{content.welcome}</p>
                        <p>{stateProfile?.dataUser?.fullname || "ผู้ใช้"}</p>
                      </div>
                    </div>
                    <div className="bBtn">
                      <a href="#" onClick={handleGotoPage} data-page="profile">
                        {content.viewProfile}
                      </a>
                    </div>
                  </div>
                  {memberPointTop3?.length && memberPointTop3.length > 0 ? (
                    <div className="bPoint">
                      <p>{content.pointsDescription}</p>
                      <div className="bTopPoint">
                        {memberPointTop3.map((val, idx) => (
                          <div className="bPointContent" key={`top3-${val.id || idx}`}>
                            <img
                              src={val.imageFileUrl}
                              alt={val.name || `Top ${idx + 1}`}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                            <p className="tName">#{`${idx + 1} ${val.name || ""}`}</p>
                            <p className="tPoint">{parseInt(val.point || 0).toLocaleString()}</p>
                            <p>{content.points}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className="bCard">
                      <div className="bCardContent">
                        <img src={img_icoSearch} alt="" />
                        <p>{content.noMemberList}</p>
                        <p>
                          {content.visitWebsite}
                          <a href={tpdUrl} target="_blank" rel="noopener noreferrer">
                            {content.ourWebsite}
                          </a>
                          {content.addMember}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="bPoint-btn">
                <a onClick={(e) => handleExternalLink(e, "myPoints")} className="btnPoint">
                  {content.myPoints}
                </a>
                <a onClick={(e) => handleExternalLink(e, "myCoupon")} className="btnCode">
                  {content.myCode}
                </a>
              </div>
            </section>

            {memberDataLoading ? (
              <LoadingSpinner text={content.loadingMemberData} size="28px" padding="60px 20px" />
            ) : (
              <>
                <section id="pMemberPayPoint">
                  <HeaderLink title={content.memberPaypoint} link={tpdUrl} onClick={(e) => handleExternalLink(e, "memberPaypoint")} />
                  <div className="bGroupApp">
                    {paypointPartners?.length && paypointPartners.length > 0 ? (
                      paypointPartners.map((val, idx) => (
                        <div className="bApp" key={`partner-${val.id || idx}`}>
                          <div className="bPic">
                            <img
                              src={val.imageFileUrl}
                              alt={val.name || "Partner"}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />
                          </div>
                          <div className="bText">
                            <p>{val.name || "ไม่ระบุชื่อ"}</p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div style={{ textAlign: "center", padding: "20px" }}>
                        <p>{content.noPartnerData}</p>
                      </div>
                    )}
                  </div>

                  {highlight?.length && highlight.length > 0 && (
                    <section>
                      <HeaderLink title={content.highlight} link={tpdUrl} onClick={(e) => handleExternalLink(e, "highlight")} />
                      <SwiperComponent slides={highlight} type="highlight" />
                    </section>
                  )}

                  {coupon?.length && coupon.length > 0 && (
                    <section>
                      <HeaderLink title={content.codes} link={tpdUrl} onClick={(e) => handleExternalLink(e, "codes")} />
                      <SwiperComponent slides={coupon} type="code" />
                    </section>
                  )}
                </section>
              </>
            )}
          </div>
        </main>
      </div>
    </>
  );
};

export default Member;
